import React from "react";
import { Link } from "react-router-dom";
import MaterialTable, { Column } from "@material-table/core";
import { Grid } from "@mui/material";

type MessageRow = {
  createdAt: string;
  interestUrl: string;
  type: string;
  recipientName: string;
  subject: string;
  statusMessage: string;
  body: string;
}
type MessagesTableProps = {
  rowData: MessageRow[];
  slideoutEnabled?: boolean;
}
const NoWrap: React.FC<{value: string}> = ({ value }) => (
  <span style={{ whiteSpace: "nowrap" }}>{value}</span>);
class MessagesTable extends React.Component<MessagesTableProps> {
  render (props = this.props): JSX.Element {
    const columns: Array<Column<MessageRow>> = [
      { title: "Name",
        field: "recipientName",
        render: ({ interestUrl, recipientName }) => {
          let to = interestUrl;
          if (props.slideoutEnabled) {
            const parts = interestUrl?.split("/interest/");
            const id = parts && parts[1] ? parts[1].split("/")[0] : "";
            if (id) to = `/dash/manager/messages/interests/${id}/activity`;
          }
          return <Link to={to}>{recipientName}</Link>;
        },
        width: 220 },
      { title: "Type", field: "type", width: 100 },
      { title: "Status Code", field: "statusMessage", width: 120 },
      { title: "Date Sent", field: "createdAt", render: ({ createdAt }) => <NoWrap value={createdAt} />, width: 130 },
      { title: "Subject", field: "subject", width: 200 },
      { title: "Message Preview", field: "body", render: ({ body }) => <NoWrap value={body} /> },
    ];
    return (
      <MaterialTable
        components={{ Container: Grid }}
        data={props.rowData}
        columns={columns}
        options={{ tableLayout: "fixed",
          pageSize: 25,
          showTitle: false,
          padding: "dense",
          search: false,
          toolbar: false }}
      />
    );
  }
}

export default MessagesTable;
